import { Button, Heading, Icon, ListItem, Stack, StackDivider, Text, UnorderedList, useToast } from "@chakra-ui/react";
import { AiFillDatabase } from "react-icons/ai";
import {
    SiXero,
    SiQuickbooks
} from "react-icons/si";
import {
    TbApi
} from 'react-icons/tb';
import { POST } from "../../utils/ApiRequestProvider";

export default function IntegrationData() {
    const toast = useToast();

    const connect = async (provider: 'xero' | 'quickbooks' | 'api') => {
        try {
            const res = await POST(`/api/integrations/${provider}/connect`, {});
            if (res.status === 'success') {
                const authUrl = res.data?.authUrl;
                if (authUrl) {
                    window.location.href = authUrl;
                    return;
                }
                toast({ title: 'Connected', status: 'success', duration: 1500, position: 'top-right' });
            } else {
                toast({ title: res.message || 'Connection failed', status: 'error', duration: 1500, position: 'top-right' });
            }
        } catch {
            toast({ title: 'Connection failed', status: 'error', duration: 1500, position: 'top-right' });
        }
    };

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'column', "2xl": "row" }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 6, "2xl": 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={AiFillDatabase}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Integration Data</Heading>
                            <Text fontSize={'sm'}>Integrate EntryBot with an online accounting software software</Text>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4} divider={<StackDivider />}>
                <Stack spacing={2}>
                    <Heading fontSize={'xl'}>Select an accounting software for integration</Heading>
                    <Stack direction={'row'} spacing={6}>
                        <Button
                            leftIcon={<SiXero fontSize={'25px'} />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'lg'}
                            onClick={() => connect('xero')}
                        >
                            Connect to Xero
                        </Button>
                        <Button
                            leftIcon={<SiQuickbooks fontSize={'25px'} />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'lg'}
                            onClick={() => connect('quickbooks')}
                        >
                            Connect to QuickBooks
                        </Button>
                        <Button
                            leftIcon={<TbApi fontSize={'25px'} />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'lg'}
                            onClick={() => connect('api')}
                        >
                            Connect via API
                        </Button>
                    </Stack>
                </Stack>
                <Stack spacing={2}>
                    <Heading fontSize={'xl'}>Note:</Heading>
                    <Text>If you intend to export invoices & receipts from EntryBot to Xero, QuickBooks online. Please integrate using relevant integration links above.</Text>
                    <Text>You can continue using EntryBot without integration, If you intend to use EntryBot for:</Text>
                    <UnorderedList px={12}>
                        <ListItem>Bank Statements data extraction only. You can download data in compatible CSV/Excel formats.</ListItem>
                        <ListItem>Invoice or Receipts data extraction but use accounting software other than Xero or Quickbooks online or if you don't have an accounting software, You can download data in CSV/Excel Formats.</ListItem>
                    </UnorderedList>
                </Stack>
            </Stack>
        </Stack>
    )
}